module.exports = __webpack_public_path__ + "img/1.36fc499c.jpg";